import axios from 'axios';
import { API_BASE_URL } from './config';

const instance = axios.create({
    baseURL: API_BASE_URL
});

// Add request interceptor to dynamically set token on each request
instance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers['x-access-token'] = token;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

instance.interceptors.response.use(
    (response) => response,
    (error) => {
        // this checks for when a token is not verified and logs you out
        if (error.response?.status === 401 || error.response?.status === 403) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            localStorage.clear(); // Clear all localStorage as fallback
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default instance;
